import ProviderPerformanceTransformer from '../../transformers/providerPerformance';
import axios from 'axios';

export default (query) => {
  const promise = new Promise((resolve, reject) => {
    let params = query || {};
    axios.get(process.env.VUE_APP_API_ADMIN_LOCATION + 'providers/performance/adjustment', { params }).then(
      ({ data }) => {
        let performanceReq = [];
        if (data.data) {
          performanceReq.data = ProviderPerformanceTransformer.fetchCollectionForTable(data.data);
          performanceReq.pagination = data.pagination;
        }
        resolve(performanceReq);
      },
      (error) => {
        reject(error);
      }
    );
  });

  return promise;
};
